import ShoeHero from "./ShoeHero.component";

export default ShoeHero;
